// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-container.adg3-editor.active-preview #toolbar {
	display: none;
}

.editor-container.adg3-editor #toolbar {
	position: static;
	display: flex;
}

.editor-container.adg3-editor #toolbar #rte-toolbar {
	padding: 5px 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default {
	padding: 0;
	top: 42px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#rte-toolbar-row-default
	.aui-buttons:first-child {
	margin-left: 5px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-more-settings-trigger
	span.aui-iconfont-configure:before {
	top: -3px;
	left: -3px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #table-highlight-group #table-highlight-colour {
	float: none;
	width: 16px;
	/* The table cell colour picker is a 'split button' with two clickable areas and needs some custom styling */
}

.editor-container.adg3-editor #toolbar #rte-toolbar #table-highlight-group {
	/* So that this stays the same color as the toolbar after a user picks a cell highlight color */
	background-color: inherit;
	margin-right: 3px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group:hover
	> .toolbar-splitbutton
	.aui-dd-parent
	a.toolbar-trigger
	.icon.icon-dropdown {
	color: var(--ds-surface-hovered, #ffffff);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group:hover
	> button.aui-button:not([disabled])
	> .icon:before {
	color: var(--ds-icon-subtle, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour.disabled
	a.toolbar-trigger:after {
	border-top-color: var(--ds-border-disabled, #405070);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour.disabled
	.aui-dd-parent:hover {
	background-color: var(--ds-surface-hovered, #ffffff);
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group
	.toolbar-splitbutton#table-highlight-colour
	.aui-dd-parent,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour
	.aui-dd-parent
	a.toolbar-trigger,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour
	.aui-dd-parent
	a.toolbar-trigger:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour
	.aui-dd-parent:hover {
	margin-right: 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #table-highlight-group .aui-button {
	margin-right: 1px;
	/* Solving Firefox rendering issues to do with implicit icon heights and vertical-alignment */
	vertical-align: top;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #table-highlight-group .aui-button .icon {
	height: 20px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group
	.aui-button
	.icon:before {
	margin-top: -2px;
	/* End of solving Firefox rendering issues */
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group
	.aui-button
	.highlight-indicator {
	position: absolute;
	padding: 0;
	width: 8px;
	height: 5px;
	margin: 2px 0 0 -6px;
	z-index: 2000;
	/* Groups the drop-down trigger with the drop-down contents */
}

.editor-container.adg3-editor #toolbar #rte-toolbar #table-highlight-group #table-highlight-colour {
	float: none;
	width: 16px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	a.toolbar-trigger {
	width: 15px;
	height: 22px;
	z-index: 1000;
	/* CONFDEV-13971 */
	box-sizing: border-box;
	-moz-box-sizing: border-box;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	a.toolbar-trigger::after {
	margin-left: -11px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	.aui-dropdown {
	overflow: auto;
	padding: 4px;
	width: 60px;
	min-width: 0;
	/* CONFDEV-8832 - On default sets a min-width of 150px - wtf! */
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	ul.table-highlight-picker {
	list-style: none;
	margin: 0;
	padding: 0;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	ul.table-highlight-picker
	li {
	display: inline;
	float: left;
	height: 16px;
	line-height: 16px;
	padding: 2px;
	width: 16px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	ul.table-highlight-picker
	li
	a {
	border: 1px solid var(--ds-border-bold, #ccc);
	border-radius: 2px;
	display: block;
	height: 14px;
	line-height: 14px;
	padding: 0px;
	text-align: justify;
	width: 14px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	#confluence-insert-files.insert-files
	.toolbar-trigger {
	margin: 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-task-lists {
	display: none;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover,
.editor-container.adg3-editor #toolbar #rte-toolbar .rte-toolbar-group-style #color-picker-control {
	width: 42px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	#rte-button-color:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	#rte-button-color:hover,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	#rte-button-color,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	#rte-button-color {
	margin: 0;
	padding: 0 2px 0 4px;
	width: 24px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	#rte-button-color:hover
	.ui-iconfont-editor-color,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	#rte-button-color:hover
	.ui-iconfont-editor-color,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	#rte-button-color
	.ui-iconfont-editor-color,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	#rte-button-color
	.ui-iconfont-editor-color {
	width: 16px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	#rte-button-color:hover
	.selected-color,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	#rte-button-color:hover
	.selected-color,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	#rte-button-color
	.selected-color,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	#rte-button-color
	.selected-color {
	margin-top: 16px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	.aui-dd-parent.dd-allocated:hover
	a.toolbar-trigger#rte-button-color-selector,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	.aui-dd-parent.dd-allocated:hover
	a.toolbar-trigger#rte-button-color-selector,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	.aui-dd-parent.dd-allocated
	a.toolbar-trigger#rte-button-color-selector,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	.aui-dd-parent.dd-allocated
	a.toolbar-trigger#rte-button-color-selector {
	width: 15px;
	margin-right: 1px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	.aui-dd-parent.dd-allocated:hover
	a.toolbar-trigger#rte-button-color-selector
	span,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	.aui-dd-parent.dd-allocated:hover
	a.toolbar-trigger#rte-button-color-selector
	span,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	.aui-dd-parent.dd-allocated
	a.toolbar-trigger#rte-button-color-selector
	span,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	.aui-dd-parent.dd-allocated
	a.toolbar-trigger#rte-button-color-selector
	span {
	width: 9px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	.aui-dd-parent.dd-allocated:hover
	a.toolbar-trigger#rte-button-color-selector:after,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	.aui-dd-parent.dd-allocated:hover
	a.toolbar-trigger#rte-button-color-selector:after,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	.aui-dd-parent.dd-allocated
	a.toolbar-trigger#rte-button-color-selector:after,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	.aui-dd-parent.dd-allocated
	a.toolbar-trigger#rte-button-color-selector:after {
	margin-left: -11px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control:hover
	.aui-icon-small.aui-iconfont-editor-color:before,
.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.rte-toolbar-group-style
	#color-picker-control
	.aui-icon-small.aui-iconfont-editor-color:before {
	font-size: 22px;
	content: '\\e90f';
	margin-left: -3px;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-primary {
	padding: 0;
}

.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary {
	padding-top: 0px;
}

.editor-container.adg3-editor
	#toolbar
	#rte-toolbar
	.aui-toolbar2-secondary
	.rte-toolbar-group-searchreplace,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary .rte-toolbar-group-help,
.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary .adg3InviteToEdit {
	display: none;
}

.editor-container.adg3-editor #toolbar #rte-toolbar #adg3-charlie-icon {
	display: none;
}

.editor-container.adg3-editor #savebar-container {
	min-height: 64px;
}

.editor-container.adg3-editor #savebar-container #rte-savebar {
	height: 48px;
	padding: 0;
}

.editor-container.adg3-editor #savebar-container #rte-savebar .toolbar-split.toolbar-split-row {
	margin-top: -3px;
}

.editor-container.adg3-editor #savebar-container #rte-savebar #rte-button-cancel.disabled {
	background: transparent;
	border-color: transparent;
	text-decoration: none;
	cursor: not-allowed;
}

.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-cancel.disabled
	.trigger-text {
	color: var(--ds-text-subtlest, #999);
}

.editor-container.adg3-editor #savebar-container #rte-savebar #rte-button-cancel {
	background-color: var(--ds-surface, #ffffff);
}

.editor-container.adg3-editor #savebar-container #rte-savebar #rte-button-cancel .trigger-text {
	color: var(--ds-text-brand, #3572b0);
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/adg3-styles/editor-comments.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,SAAS;AACV;;AAEA;;;;;CAKC,gBAAgB;AACjB;;AAEA;;;;;CAKC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,WAAW;CACX,WAAW;CACX,4GAA4G;AAC7G;;AAEA;CACC,+FAA+F;CAC/F,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;;;;;;;;CAQC,yCAAyC;AAC1C;;AAEA;;;;;;CAMC,qCAAqC;AACtC;;AAEA;;;;;;CAMC,oDAAoD;AACrD;;AAEA;;;;;;CAMC,oDAAoD;AACrD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;CA0BC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,6FAA6F;CAC7F,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;;;;;;CAMC,gBAAgB;CAChB,4CAA4C;AAC7C;;AAEA;;;;;;CAMC,kBAAkB;CAClB,UAAU;CACV,UAAU;CACV,WAAW;CACX,oBAAoB;CACpB,aAAa;CACb,6DAA6D;AAC9D;;AAEA;CACC,WAAW;CACX,WAAW;AACZ;;AAEA;;;;;;CAMC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;;;;;;CAMC,kBAAkB;AACnB;;AAEA;;;;;;CAMC,cAAc;CACd,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,+DAA+D;AAChE;;AAEA;;;;;;CAMC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;;;;;;;CAOC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,YAAY;CACZ,WAAW;AACZ;;AAEA;;;;;;;;CAQC,6CAA6C;CAC7C,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,YAAY;CACZ,mBAAmB;CACnB,WAAW;AACZ;;AAEA;;;;;CAKC,SAAS;AACV;;AAEA;CACC,aAAa;AACd;;AAEA;;;;;;CAMC,WAAW;AACZ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC,SAAS;CACT,oBAAoB;CACpB,WAAW;AACZ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC,WAAW;AACZ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC,WAAW;CACX,iBAAiB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAgCC,UAAU;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC,kBAAkB;AACnB;;AAEA;;;;;;;;;;;;CAYC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;;;;;CAOC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,yBAAyB;CACzB,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;;;;;CAKC,oCAAoC;AACrC;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,oCAAoC;AACrC","sourcesContent":[".editor-container.adg3-editor.active-preview #toolbar {\n\tdisplay: none;\n}\n\n.editor-container.adg3-editor #toolbar {\n\tposition: static;\n\tdisplay: flex;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar {\n\tpadding: 5px 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #rte-toolbar-row-default {\n\tpadding: 0;\n\ttop: 42px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#rte-toolbar-row-default\n\t.aui-buttons:first-child {\n\tmargin-left: 5px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-more-settings-trigger\n\tspan.aui-iconfont-configure:before {\n\ttop: -3px;\n\tleft: -3px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #table-highlight-group #table-highlight-colour {\n\tfloat: none;\n\twidth: 16px;\n\t/* The table cell colour picker is a 'split button' with two clickable areas and needs some custom styling */\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #table-highlight-group {\n\t/* So that this stays the same color as the toolbar after a user picks a cell highlight color */\n\tbackground-color: inherit;\n\tmargin-right: 3px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t> .toolbar-splitbutton\n\t.aui-dd-parent\n\ta.toolbar-trigger\n\t.icon.icon-dropdown {\n\tcolor: var(--ds-surface-hovered, #ffffff);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t> button.aui-button:not([disabled])\n\t> .icon:before {\n\tcolor: var(--ds-icon-subtle, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour.disabled\n\ta.toolbar-trigger:after {\n\tborder-top-color: var(--ds-border-disabled, #405070);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour.disabled\n\t.aui-dd-parent:hover {\n\tbackground-color: var(--ds-surface-hovered, #ffffff);\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t.toolbar-splitbutton#table-highlight-colour\n\t.aui-dd-parent,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour\n\t.aui-dd-parent\n\ta.toolbar-trigger,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour\n\t.aui-dd-parent\n\ta.toolbar-trigger:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour\n\t.aui-dd-parent:hover {\n\tmargin-right: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #table-highlight-group .aui-button {\n\tmargin-right: 1px;\n\t/* Solving Firefox rendering issues to do with implicit icon heights and vertical-alignment */\n\tvertical-align: top;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #table-highlight-group .aui-button .icon {\n\theight: 20px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t.aui-button\n\t.icon:before {\n\tmargin-top: -2px;\n\t/* End of solving Firefox rendering issues */\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t.aui-button\n\t.highlight-indicator {\n\tposition: absolute;\n\tpadding: 0;\n\twidth: 8px;\n\theight: 5px;\n\tmargin: 2px 0 0 -6px;\n\tz-index: 2000;\n\t/* Groups the drop-down trigger with the drop-down contents */\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #table-highlight-group #table-highlight-colour {\n\tfloat: none;\n\twidth: 16px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\ta.toolbar-trigger {\n\twidth: 15px;\n\theight: 22px;\n\tz-index: 1000;\n\t/* CONFDEV-13971 */\n\tbox-sizing: border-box;\n\t-moz-box-sizing: border-box;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\ta.toolbar-trigger::after {\n\tmargin-left: -11px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\t.aui-dropdown {\n\toverflow: auto;\n\tpadding: 4px;\n\twidth: 60px;\n\tmin-width: 0;\n\t/* CONFDEV-8832 - On default sets a min-width of 150px - wtf! */\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\tul.table-highlight-picker {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\tul.table-highlight-picker\n\tli {\n\tdisplay: inline;\n\tfloat: left;\n\theight: 16px;\n\tline-height: 16px;\n\tpadding: 2px;\n\twidth: 16px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\tul.table-highlight-picker\n\tli\n\ta {\n\tborder: 1px solid var(--ds-border-bold, #ccc);\n\tborder-radius: 2px;\n\tdisplay: block;\n\theight: 14px;\n\tline-height: 14px;\n\tpadding: 0px;\n\ttext-align: justify;\n\twidth: 14px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t#confluence-insert-files.insert-files\n\t.toolbar-trigger {\n\tmargin: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar ul.aui-buttons.rte-toolbar-group-task-lists {\n\tdisplay: none;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover,\n.editor-container.adg3-editor #toolbar #rte-toolbar .rte-toolbar-group-style #color-picker-control {\n\twidth: 42px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t#rte-button-color:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t#rte-button-color:hover,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t#rte-button-color,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t#rte-button-color {\n\tmargin: 0;\n\tpadding: 0 2px 0 4px;\n\twidth: 24px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t#rte-button-color:hover\n\t.ui-iconfont-editor-color,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t#rte-button-color:hover\n\t.ui-iconfont-editor-color,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t#rte-button-color\n\t.ui-iconfont-editor-color,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t#rte-button-color\n\t.ui-iconfont-editor-color {\n\twidth: 16px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t#rte-button-color:hover\n\t.selected-color,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t#rte-button-color:hover\n\t.selected-color,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t#rte-button-color\n\t.selected-color,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t#rte-button-color\n\t.selected-color {\n\tmargin-top: 16px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t.aui-dd-parent.dd-allocated:hover\n\ta.toolbar-trigger#rte-button-color-selector,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t.aui-dd-parent.dd-allocated:hover\n\ta.toolbar-trigger#rte-button-color-selector,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t.aui-dd-parent.dd-allocated\n\ta.toolbar-trigger#rte-button-color-selector,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t.aui-dd-parent.dd-allocated\n\ta.toolbar-trigger#rte-button-color-selector {\n\twidth: 15px;\n\tmargin-right: 1px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t.aui-dd-parent.dd-allocated:hover\n\ta.toolbar-trigger#rte-button-color-selector\n\tspan,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t.aui-dd-parent.dd-allocated:hover\n\ta.toolbar-trigger#rte-button-color-selector\n\tspan,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t.aui-dd-parent.dd-allocated\n\ta.toolbar-trigger#rte-button-color-selector\n\tspan,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t.aui-dd-parent.dd-allocated\n\ta.toolbar-trigger#rte-button-color-selector\n\tspan {\n\twidth: 9px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t.aui-dd-parent.dd-allocated:hover\n\ta.toolbar-trigger#rte-button-color-selector:after,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t.aui-dd-parent.dd-allocated:hover\n\ta.toolbar-trigger#rte-button-color-selector:after,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t.aui-dd-parent.dd-allocated\n\ta.toolbar-trigger#rte-button-color-selector:after,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t.aui-dd-parent.dd-allocated\n\ta.toolbar-trigger#rte-button-color-selector:after {\n\tmargin-left: -11px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control:hover\n\t.aui-icon-small.aui-iconfont-editor-color:before,\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.rte-toolbar-group-style\n\t#color-picker-control\n\t.aui-icon-small.aui-iconfont-editor-color:before {\n\tfont-size: 22px;\n\tcontent: '\\e90f';\n\tmargin-left: -3px;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-primary {\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary {\n\tpadding-top: 0px;\n}\n\n.editor-container.adg3-editor\n\t#toolbar\n\t#rte-toolbar\n\t.aui-toolbar2-secondary\n\t.rte-toolbar-group-searchreplace,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary .rte-toolbar-group-help,\n.editor-container.adg3-editor #toolbar #rte-toolbar .aui-toolbar2-secondary .adg3InviteToEdit {\n\tdisplay: none;\n}\n\n.editor-container.adg3-editor #toolbar #rte-toolbar #adg3-charlie-icon {\n\tdisplay: none;\n}\n\n.editor-container.adg3-editor #savebar-container {\n\tmin-height: 64px;\n}\n\n.editor-container.adg3-editor #savebar-container #rte-savebar {\n\theight: 48px;\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor #savebar-container #rte-savebar .toolbar-split.toolbar-split-row {\n\tmargin-top: -3px;\n}\n\n.editor-container.adg3-editor #savebar-container #rte-savebar #rte-button-cancel.disabled {\n\tbackground: transparent;\n\tborder-color: transparent;\n\ttext-decoration: none;\n\tcursor: not-allowed;\n}\n\n.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-cancel.disabled\n\t.trigger-text {\n\tcolor: var(--ds-text-subtlest, #999);\n}\n\n.editor-container.adg3-editor #savebar-container #rte-savebar #rte-button-cancel {\n\tbackground-color: var(--ds-surface, #ffffff);\n}\n\n.editor-container.adg3-editor #savebar-container #rte-savebar #rte-button-cancel .trigger-text {\n\tcolor: var(--ds-text-brand, #3572b0);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
